/**
 * 파일명: serviceTerms.en.js
 * 설명: 서비스 이용 약관 전문 (영문)
 *
 * 주의: 법적 효력의 기준은 한국어 원문(serviceTerms.ko.js)이며 본 영문본은 이해를 돕기 위한 참고 번역입니다.
 */
const serviceTermsEn = {
  title: "Terms of Service",
  notice:
    "This English version is provided for reference only. In the event of any discrepancy, the Korean original shall prevail.",
  sections: [
    {
      title: "Article 1 (Purpose)",
      blocks: [
        {
          type: "p",
          text: "These Terms set forth the rights, obligations, and responsibilities of the Company and the User with respect to the use of the internet-related services (hereinafter the “Services”) provided at https://allplace.kr (hereinafter the “Company”), operated by RIV Technology Co., Ltd.",
        },
      ],
    },
    {
      title: "Article 2 (Definitions)",
      blocks: [
        {
          type: "p",
          text: "① The “Services” mean a cloud-based workplace management service that enables a company to manage meeting room reservations, meeting room devices, hot-desking, and video conferencing systems on a single platform.",
        },
        {
          type: "p",
          text: "② “User” means a Full Member or General Member who accesses the “Company” and receives the Services provided by the “Company” under these Terms.",
        },
        {
          type: "p",
          text: "③ “Full Member”: a corporation or individual that, as a party to a paid service agreement, has submitted a service subscription application to the “Company”, has been approved by the “Company”, and bears the obligation to pay the service fees.",
        },
        {
          type: "p",
          text: "④ “General Member”: a person who has agreed to the terms of use of the site operated by the “Company” and has been registered as a “Member” through the ‘application and approval’ procedure.",
        },
        {
          type: "p",
          text: "⑤ “Password”: a combination of letters, numbers, and special characters chosen by a Member to protect their own confidentiality in communications, in relation to the ID granted to the Member.",
        },
        {
          type: "p",
          text: "⑥ “Agreement”: the agreement entered into between the “Company” and a Member in relation to the use of the Services.",
        },
        {
          type: "p",
          text: "⑦ “Withdrawal of Service”: the termination of the service agreement, effective going forward, by the “Company” or a Member (including an applicant for membership) after the Service has been activated.",
        },
        {
          type: "p",
          text: "⑧ “Posting”: text, photographs, videos, files, links, and other information in the form of symbols, characters, voice, sound, images, or moving images that a Member posts on a device (including PCs, mobile devices, TVs, and other wired or wireless devices) or on the “Company” website in the course of using the Services.",
        },
        {
          type: "p",
          text: "⑨ “Service Fee”: the usage fee that a User pays to the Company in order to use the Services.",
        },
      ],
    },
    {
      title: "Article 3 (Posting, Explanation, and Amendment of the Terms)",
      blocks: [
        {
          type: "p",
          text: "① The “Company” shall post the contents of these Terms, together with its trade name, the name of its representative, the address of its place of business (including the address at which consumer complaints may be handled), telephone number, e-mail address, business registration number, mail-order business registration number, and the person responsible for personal information management, on the initial service screen (front page) of the Company so that Users can easily identify them. However, the contents of these Terms may be made available for Users to view through a linked screen.",
        },
        {
          type: "p",
          text: "② Before a User agrees to these Terms, the “Company” shall provide a separate linked screen or pop-up screen so that the User can understand important matters stipulated in these Terms, such as refund conditions, and shall obtain the User's confirmation.",
        },
        {
          type: "p",
          text: "③ The “Company” may amend these Terms to the extent that such amendment does not violate the Content Industry Promotion Act, the Act on the Consumer Protection in Electronic Commerce, the Act on the Regulation of Terms and Conditions, the Framework Act on Consumers, or other related laws.",
        },
        {
          type: "p",
          text: "④ Where the “Company” amends these Terms, it shall announce the effective date and the reasons for the amendment, together with the current Terms, on the initial screen of the Company from seven days before the effective date until the day preceding the effective date. However, where the Terms are amended in a manner unfavorable to Users, the announcement shall be made with a prior grace period of at least thirty days. In such case, the “Company” shall clearly compare the contents before and after the amendment so that Users can readily understand them.",
        },
        {
          type: "p",
          text: "⑤ Where the “Company” amends these Terms, the amended Terms shall apply only to agreements concluded on or after the effective date, and the provisions in force prior to the amendment shall continue to apply to agreements already concluded. However, where a User who has already concluded an agreement transmits to the “Company”, within the announcement period under Paragraph 4, an intention to be governed by the amended provisions and obtains the consent of the “Company”, the amended provisions shall apply.",
        },
        {
          type: "p",
          text: "⑥ Matters not stipulated in these Terms and the interpretation of these Terms shall be governed by the Act on the Consumer Protection in Electronic Commerce, the Act on the Regulation of Terms and Conditions, the Guidelines for Consumer Protection in Electronic Commerce established by the Fair Trade Commission, and other relevant laws or commercial practice.",
        },
        {
          type: "p",
          text: "⑦ A Member who does not agree to an amendment of these Terms may discontinue use of the Services and terminate the service agreement (withdraw membership). A Member who has not withdrawn membership by the effective date of the amended Terms shall be deemed to have agreed to the amended Terms.",
        },
      ],
    },
    {
      title: "Article 4 (Provision and Modification of the Services)",
      blocks: [
        {
          type: "p",
          text: "① The “Company” performs the following operations.",
        },
        {
          type: "ol",
          items: [
            "Provision of workplace management services, including meeting room reservation and management, meeting room device management, hot-desking, and video conferencing",
            "Provision of convenience features such as dashboards and statistics based on analysis of meeting room and seat usage data",
            "Provision of integration with external professional video conferencing platforms",
            "Provision of information about the Services and other operations determined by the “Company”",
          ],
        },
        {
          type: "p",
          text: "② Where the Services are discontinued or technical specifications change, the “Company” may modify the content of the Services to be provided under agreements to be concluded in the future. In such case, the “Company” shall specify the modified content and the date of provision and immediately announce them where the current content of the Services is posted.",
        },
        {
          type: "p",
          text: "③ Where the “Company” modifies the content of Services it has agreed to provide to a User due to discontinuation of the Services, changes in technical specifications, or similar reasons, it shall immediately notify the User of the reasons by any method by which notification is possible.",
        },
        {
          type: "p",
          text: "④ In the case of the preceding paragraph, the “Company” shall compensate the User for any damage sustained as a result. However, this shall not apply where the “Company” proves that it acted without intent or negligence.",
        },
      ],
    },
    {
      title: "Article 5 (Suspension of the Services)",
      blocks: [
        {
          type: "p",
          text: "① The “Company” may temporarily suspend the provision of the Services in the event of maintenance, inspection, replacement, or breakdown of computers and other information and communications equipment, interruption of communications, or similar circumstances.",
        },
        {
          type: "p",
          text: "② The “Company” shall compensate Users or third parties for damage sustained as a result of a temporary suspension of the Services for the reasons set out in Paragraph 1. However, this shall not apply where the “Company” proves that it acted without intent or negligence.",
        },
        {
          type: "p",
          text: "③ Where the Services can no longer be provided due to a change of business line, discontinuation of business, a merger between companies, or similar reasons, the “Company” shall notify Users by the method prescribed in Article 8 and shall compensate consumers in accordance with the conditions originally presented by the “Company”.",
        },
      ],
    },
    {
      title: "Article 6 (Membership Registration)",
      blocks: [
        {
          type: "p",
          text: "① A User applies for membership by entering their member information in accordance with the registration form prescribed by the “Company” and then indicating their intention to agree to these Terms.",
        },
        {
          type: "p",
          text: "② The “Company” shall register as a Member any User who has applied for membership under Paragraph 1, unless the User falls under any of the following:",
        },
        {
          type: "ul",
          items: [
            "An application made in the name of another person",
            "Where the registered information contains falsehoods, omissions, or errors",
            "Where registering the applicant as a Member would otherwise cause significant technical difficulty for the “Company”",
            "Where acceptance of the application is difficult for reasons attributable to the applicant",
          ],
        },
        {
          type: "p",
          text: "③ The membership agreement shall be deemed formed at the time the acceptance of the “Company” reaches the Member.",
        },
        {
          type: "p",
          text: "④ Where there is any change to their registered information, a Member shall immediately notify the “Company” of such change by e-mail or other means.",
        },
      ],
    },
    {
      title: "Article 7 (Withdrawal of Membership and Loss of Eligibility)",
      blocks: [
        {
          type: "p",
          text: "① A Member may request withdrawal from the “Company” at any time, and the “Company” shall process the withdrawal immediately.",
        },
        {
          type: "p",
          text: "② Where a Member falls under any of the following, the “Company” may restrict or suspend the Member's eligibility:",
        },
        {
          type: "ul",
          items: [
            "Where false information was registered at the time of application",
            "Where the Member fails to pay, by the due date, service fees or other debts borne by the Member in connection with use of the “Company” Services",
            "Where the Member threatens the order of electronic commerce, such as by interfering with another person's use of the “Company” or misappropriating another person's information",
            "Where the Member uses the “Company” to engage in acts prohibited by law or by these Terms, or contrary to public order and good morals",
          ],
        },
        {
          type: "p",
          text: "③ Where the “Company” causes a Member to lose eligibility, it shall grant the Member a seven-day opportunity to submit an explanation. As this measure is intended to prevent member information from being deleted contrary to the Member's intention, the membership registration shall be cancelled where the Member does not present their views to the Company within that period or disregards the opportunity to submit an explanation.",
        },
      ],
    },
    {
      title: "Article 8 (Notice to Members)",
      blocks: [
        {
          type: "p",
          text: "① Where the “Company” gives notice to a Member, it may do so to the e-mail address designated in advance by agreement between the Member and the “Company”.",
        },
        {
          type: "p",
          text: "② In the case of notice to an unspecified number of Members, the “Company” may substitute individual notice by posting the notice on the “Company” website for at least one week. However, individual notice shall be given for matters that have a material effect on a Member's own transactions.",
        },
      ],
    },
    {
      title: "Article 9 (Application for Services)",
      blocks: [
        {
          type: "p",
          text: "A User applies for the Services on the “Services” by the following or a similar method, and the “Company” shall provide each of the following items in a readily understandable manner when a User applies for the Services:",
        },
        {
          type: "ol",
          items: [
            "Review and selection of pricing plans and service items",
            "Entry of company name, name, e-mail address, and the like",
            "Confirmation regarding the contents of the Terms, Services for which the right of refund is restricted, and the like",
            "Application to use the Services, and confirmation thereof or consent to the confirmation by the “Company”",
            "Selection of a payment method",
          ],
        },
      ],
    },
    {
      title: "Article 10 (Formation of the Service Agreement)",
      blocks: [
        {
          type: "p",
          text: "① The “Company” may decline to accept an application for the Services under Article 9 where any of the following applies:",
        },
        {
          type: "ol",
          items: [
            "Where the contents of the application contain falsehoods, omissions, or errors",
            "Where accepting the application for the Services would otherwise cause significant technical difficulty for the “Company”",
          ],
        },
        {
          type: "p",
          text: "② The agreement shall be deemed formed at the time the acceptance of the “Company” reaches the User in the form of the confirmation of receipt under Article 12, Paragraph 1.",
        },
        {
          type: "p",
          text: "③ The “Company”'s expression of acceptance shall include confirmation of the User's application for the Services and information regarding correction or cancellation of the application.",
        },
      ],
    },
    {
      title: "Article 11 (Methods of Payment)",
      blocks: [
        {
          type: "p",
          text: "Payment for Services applied for from the “Company” may be made by any available method among the following. However, the “Company” may not collect any additional fee of any nature on the service fees in relation to the User's method of payment.",
        },
        {
          type: "ol",
          items: [
            "Account transfers of various kinds, including phone banking, internet banking, and open banking",
            "Card payments of various kinds, including credit cards",
            "Online bank deposit without a passbook",
            "Payment by other electronic means of payment",
          ],
        },
      ],
    },
    {
      title:
        "Article 12 (Confirmation of Receipt / Modification and Cancellation of Service Applications)",
      blocks: [
        {
          type: "p",
          text: "① Where a User submits an application for the Services, the “Company” shall send the User a confirmation of receipt.",
        },
        {
          type: "p",
          text: "② A User who has received a confirmation of receipt may, in the event of a discrepancy in the expression of intent or the like, request modification or cancellation of the application immediately after receiving the confirmation of receipt. However, where payment has already been made, the provisions on withdrawal of Service under Article 15 shall apply.",
        },
      ],
    },
    {
      title: "Article 13 (Supply of the Services)",
      blocks: [
        {
          type: "p",
          text: "① Unless otherwise agreed with the User as to the time of supply of the Services, the “Company” shall take the measures necessary to enable use of the Services from the date on which payment is approved.",
        },
        {
          type: "p",
          text: "② The “Company” shall specify the method of use, related programs, usage guidance, and the like for the Services a User has applied for.",
        },
      ],
    },
    {
      title: "Article 14 (Service Fees)",
      blocks: [
        {
          type: "p",
          text: "① The types of fees for paid Services shall follow the rules established on each individual website, separately from these Terms.",
        },
        {
          type: "p",
          text: "② Where a Member uses a paid Service among the Services provided by the Company, the Member shall, as a general rule, use the Service after paying the applicable fee.",
        },
        {
          type: "p",
          text: "③ Payment methods for fees for paid Services provided by the Company include credit card payment, real-time account transfer, and virtual account transfer, and the available payment methods may differ for each paid Service.",
        },
        {
          type: "p",
          text: "④ The “Company” may additionally request personal information of a Member that is strictly necessary to carry out payment, and the Member shall accurately provide the personal information requested by the Company.",
        },
        {
          type: "p",
          text: "⑤ Where a Member overpays or mispays a fee, the “Company” shall refund the fee or offset it against the next fee. However, where the overpayment arises from the Member's intent or fault, the costs required for the refund shall be borne by the Member within a reasonable scope.",
        },
      ],
    },
    {
      title: "Article 15 (Withdrawal of Service)",
      blocks: [
        {
          type: "p",
          text: "① A User who has concluded an agreement with the “Company” concerning the use of the Services may apply to withdraw the Service within seven days from the date on which the application for the Service was approved.",
        },
        {
          type: "p",
          text: "② Even where the Services provided differ from what the User expected, the User may apply to withdraw the Service within seven days as provided in Paragraph 1.",
        },
        {
          type: "p",
          text: "③ Where, for any reason, a withdrawal of Service is requested on justifiable grounds attributable to the User, and the service fees were paid by credit card or electronic money used by the User, the User may request without delay that the business operator that provided such payment method suspend or cancel the charge.",
        },
        {
          type: "p",
          text: "④ Where the service agreement is terminated, all Postings registered under the Member's account and all personal information shall be deleted. However, Postings registered or quoted by other Members in shared spaces may not be deleted.",
        },
        {
          type: "p",
          text: "⑤ Where a Member violates the provisions of these Terms, the “Company” may unilaterally terminate the service agreement, and where damage to the operation of the Services results therefrom, the “Company” may also pursue civil and criminal liability for such damage.",
        },
      ],
    },
    {
      title: "Article 16 (Refund Criteria upon Withdrawal of Service)",
      blocks: [
        {
          type: "p",
          text: "① Where a customer requesting termination of the Service wishes a refund of the amount paid, the customer shall apply for termination and refund in a manner recognized by the Company.",
        },
        {
          type: "p",
          text: "② Refund criteria by service period for paid Services shall follow the pricing rules posted on the individual website, separately from these Terms.",
        },
        {
          type: "p",
          text: "③ Where a Member requests a refund, the Company may, after confirming the purchase history, request the Member to submit the documents specified in the following items for identity verification, and the Member shall submit the requested documents to the Company by e-mail or similar means:",
        },
        {
          type: "ul",
          items: [
            "One copy of a bankbook in the name of the person or company requesting the refund",
            "One copy of a document verifying the identity of the person requesting the refund (may not be required depending on the circumstances)",
            "One copy of the receipt for the payment made (may not be required depending on the circumstances)",
          ],
        },
        {
          type: "p",
          text: "④ Where the “Company” determines that the reasons presented by the User are justified under the Service usage rules, it shall comply with the request for withdrawal of Service without delay and refund the full amount of the usage fee.",
        },
        {
          type: "p",
          text: "⑤ Where the Service is suspended or a malfunction occurs for three days or more, the “Company” shall permit termination of the agreement and refund the usage fee for the remaining period. However, the suspension or malfunction time shall be calculated from the time the consumer notifies the Company, and as a general rule, time during which the Service is suspended due to force majeure (such as a natural disaster) or pursuant to prior notice by the operator shall be excluded from that calculation.",
        },
      ],
    },
    {
      title: "Article 17 (Protection of Personal Information)",
      blocks: [
        {
          type: "p",
          text: "① When collecting information from a User, the “Company” collects the minimum information necessary to provide the Services. The following items are mandatory, and all other items are optional:",
        },
        {
          type: "ol",
          items: [
            "E-mail address",
            "Company name (in the case of a Member)",
            "Name (in the case of a Member)",
            "Password (in the case of a Member)",
          ],
        },
        {
          type: "p",
          text: "② Where the “Company” collects personal information by which a User can be personally identified, it shall obtain the consent of that User.",
        },
        {
          type: "p",
          text: "③ Personal information provided may not be used for purposes other than those intended, or provided to third parties, without the consent of the relevant User. The following cases, however, are exceptions:",
        },
        {
          type: "ol",
          items: [
            "Where information is provided in a form in which specific individuals cannot be identified, as necessary for statistical purposes, academic research, or market research",
            "Where necessary for the settlement of payments arising from use of the Services",
            "Where necessary for identity verification to prevent misappropriation",
            "Where there are unavoidable reasons required by the provisions of law or by law",
          ],
        },
        {
          type: "p",
          text: "④ Where the “Company” is required to obtain the User's consent under Paragraphs 2 and 3, it shall notify the User in advance of the matters prescribed in Articles 15 and 22 of the Personal Information Protection Act, including the purposes of collection and use of the personal information, the categories of personal information collected, the retention and use period, and the fact that the User has the right to refuse consent together with the disadvantages of such refusal, and the User may withdraw such consent at any time.",
        },
        {
          type: "p",
          text: "⑤ A User may at any time request to view and correct errors in their own personal information held by the “Company”, and the “Company” is obliged to take the necessary measures without delay. Where a User requests correction of an error, the “Company” shall not use the relevant personal information until the error has been corrected.",
        },
        {
          type: "p",
          text: "⑥ For the protection of personal information, the “Company” shall limit and minimize the number of administrators, and shall compensate Users for damage sustained where a User's personal information is lost, stolen, leaked, or altered through the intent or negligence of the “Company”.",
        },
        {
          type: "p",
          text: "⑦ The “Company”, or any third party that has received personal information from it, shall destroy the relevant personal information without delay once the purpose of collection or the purpose for which it was provided has been achieved.",
        },
        {
          type: "p",
          text: "⑧ Other details of personal information processing — including the purposes of processing, retention periods, destruction procedures, and how data subjects may exercise their rights — are governed by the Privacy Policy separately disclosed by the “Company”.",
        },
      ],
    },
    {
      title: "Article 18 (Obligations of the “Company”)",
      blocks: [
        {
          type: "p",
          text: "① The “Company” shall not engage in acts prohibited by law or by these Terms, or contrary to public order and good morals, and shall use its best efforts to provide the Services continuously and reliably in accordance with these Terms.",
        },
        {
          type: "p",
          text: "② The “Company” shall put in place a security system to protect Users' personal information (including credit information) so that Users can use internet services safely.",
        },
        {
          type: "p",
          text: "③ The “Company” shall not send commercial advertising e-mail that Users do not want.",
        },
      ],
    },
    {
      title:
        "Article 19 (Obligations Regarding the Member's ID and Password)",
      blocks: [
        {
          type: "p",
          text: "① Except where caused by the intent or negligence of the “Company”, responsibility for the management of the ID and password rests with the Member.",
        },
        {
          type: "p",
          text: "② A Member shall not allow a third party to use their ID or password.",
        },
        {
          type: "p",
          text: "③ Where a Member becomes aware that their ID or password has been stolen or is being used by a third party, the Member shall immediately notify the “Company” and shall follow any guidance provided by the “Company”.",
        },
      ],
    },
    {
      title: "Article 20 (Obligations of the User)",
      blocks: [
        {
          type: "p",
          text: "Users shall not engage in the following acts, and the “Company” may take measures to restrict use of the Services:",
        },
        {
          type: "ol",
          items: [
            "Registering false information when applying or making changes",
            "Misappropriating another person's information",
            "Altering information posted on the “Company”",
            "Transmitting or posting information (such as computer programs) other than the information designated by the “Company”",
            "Infringing the copyright or other intellectual property rights of the “Company” or any third party",
            "Acts that damage the reputation of, or interfere with the business of, the “Company” or any third party",
            "Disclosing or posting obscene or violent messages, images, audio, or other information contrary to public order and good morals on the Company",
            "Acts that increase traffic so as to interfere with the operation of the “Company” site",
          ],
        },
      ],
    },
    {
      title:
        "Article 21 (Attribution of Copyright and Restrictions on Use)",
      blocks: [
        {
          type: "p",
          text: "① Copyright and other intellectual property rights in works created by the “Company” belong to the “Company”. It is prohibited to alter, copy, distribute, publish, exhibit, or sell the Company's service works, directly or indirectly, or to use them for product creation or for information services of any kind, including the internet, mobile, and databases, without the Company's prior permission.",
        },
        {
          type: "p",
          text: "② When a Member creates a Posting directly in relation to the “Company”'s Services, the Member shall observe the following so as not to infringe the intellectual property rights of third parties:",
        },
        {
          type: "ul",
          items: [
            "Where a Posting contains a quotation, and that quotation forms the substance of the content rather than merely supporting the opinion of the Member or User, it constitutes copyright infringement even if the source is cited. Accordingly, creative works must not be posted without the express consent of the original copyright holder.",
            "Posting, reprinting, copying, redistributing, altering, or selling all or part of content created by the original copyright holder without that holder's express consent constitutes copyright infringement even if the source is cited. Accordingly, such Postings must not be posted or sold without the express consent of the original copyright holder.",
            "Where an objection is raised by a third party against material registered by a Member or an affiliate company on the grounds of infringement of copyright or other rights, defamation, obscenity, or the like, the “Company” may temporarily delete the relevant Posting. The temporarily deleted Posting may be re-registered only where, after the legal issues concerning the Posting have been concluded between the objecting party and the person who registered it through litigation, settlement, or otherwise, an application is made to the Company on that basis. Under no circumstances shall the “Company” bear responsibility for legal issues between a third party and a Member, or between a third party and an affiliate company.",
          ],
        },
      ],
    },
    {
      title: "Article 22 (Disclaimers)",
      blocks: [
        {
          type: "p",
          text: "① Where the Company's Services cannot be provided due to a natural disaster, war, or other equivalent force majeure, the Company is released from responsibility for the provision of the Services.",
        },
        {
          type: "p",
          text: "② The “Company” shall not be liable for any impediment to the use of the Services or damage caused by reasons attributable to a Member.",
        },
        {
          type: "p",
          text: "③ The “Company” shall not bear responsibility where it is unable to provide the Services because a telecommunications carrier suspended the provision of telecommunications services or failed to provide them normally.",
        },
        {
          type: "p",
          text: "④ The “Company” shall not be liable for damage arising from unavoidable reasons such as repair, replacement, regular inspection, or construction of service equipment. However, where the “Company” acted with intent or negligence, Article 5, Paragraph 2 shall apply.",
        },
        {
          type: "p",
          text: "⑤ A Member is responsible for the security of the mandatory registration items (e-mail address and the like) and the password that the Member registered with the Company in relation to the “Company”'s Services, and the “Company” shall not be liable for damage arising from the leakage of member information such as the ID or password due to the Member's intent or negligence.",
        },
        {
          type: "p",
          text: "⑥ The “Company” shall not be liable where damage arises from an error in a Member's computer, or where damage arises because a Member entered their personal details or e-mail address inaccurately.",
        },
        {
          type: "p",
          text: "⑦ The “Company” has no obligation to intervene in disputes arising between Members, or between a Member and a third party, through the medium of the Services, and shall not be liable to compensate for damage arising therefrom.",
        },
        {
          type: "p",
          text: "⑧ The Company shall not be responsible for the validity, suitability, legal reasonableness, or copyright compliance of content included in companies (other online sites) linked to or affiliated with the Company site, and shall not be liable for any damage arising therefrom.",
        },
        {
          type: "p",
          text: "⑨ The exclusions of liability in Paragraphs 1 through 8 do not apply to damage caused by the intent or gross negligence of the “Company”.",
        },
      ],
    },
    {
      title: "Article 23 (Dispute Resolution)",
      blocks: [
        {
          type: "p",
          text: "① The “Company” shall establish and operate a damage compensation body in order to reflect legitimate opinions or complaints raised by Users and to compensate for the resulting damage.",
        },
        {
          type: "p",
          text: "② The “Company” shall give priority to handling complaints and opinions submitted by Users. However, where prompt handling is difficult, the “Company” shall immediately notify the User of the reasons and the schedule for handling.",
        },
        {
          type: "p",
          text: "③ Where a User applies for remedy in relation to an electronic commerce dispute arising between the “Company” and the User, the matter may be subject to mediation by a dispute mediation body entrusted by the Fair Trade Commission or the competent Mayor/Do Governor.",
        },
        {
          type: "p",
          text: "④ Where a User commercially reuses the “Company”'s Services or works, or provides them to a third party for profit, the “Company” may take the legal measures necessary under the Copyright Act and other relevant statutes, and may claim compensation for the resulting damage.",
        },
      ],
    },
    {
      title: "Article 24 (Miscellaneous)",
      blocks: [
        {
          type: "p",
          text: "If you have any inconvenience in connection with a violation of these Terms or the use of the Services, please contact the customer support center.",
        },
        {
          type: "p",
          text: "☏ Inquiries: [Main] 070-7798-1311 (Weekdays 09:30–18:30, lunch 11:50–13:00)",
        },
        { type: "p", text: "✉ E-mail: support@riv-tech.co.kr" },
      ],
    },
  ],
};

export default serviceTermsEn;
